import { Badges } from "./Badges";
import { Countdown } from "./Countdown";
import { List } from "./List";

export const PaywallCustomization = Object.assign(List, {
  Badges,
  Countdown,
});
